import { type, AttributesMixin, define, attributes } from "@type-r/models";
import { Address } from "./address";
import { AssetData, AssetType } from "./assetData";
import { Component } from "./component";

const SaleOrder = attributes({
    uid: type(String).value('00000000-0000-0000-0000-000000000000'),
    number: String,
    date: type(Date).null
});

const Quote = attributes({
    uid: type(String).value('00000000-0000-0000-0000-000000000000'),
    number: String,
    date: type(Date).null
});

const Details = attributes({
    saleOrder: SaleOrder,
    quote: Quote
});

const Shipping = attributes({
    account: String,
    carrier: String,
    instruction: String,
    method: String,
    planDeliveryDate: type(Date).null
});

const Contact = attributes({
    name: String,
    phone: String,
    email: String
});

const ShipTo = attributes({
    name: String,
    address: Address,
    contact: Contact,
});

const BillTo = attributes({
    name: String,
    address: Address,
    contact: Contact,
});

const Supplier = attributes({
    name: String,
    externalId: String,
    address: Address,
    contact: Contact,
});

const Customer = attributes({
    name: String,
    externalId: String,
    address: Address,
    contact: Contact,
});

export interface PurchaseOrder extends AttributesMixin<typeof PurchaseOrder> { }
@define
export class PurchaseOrder extends AssetData {

    static attributes = {
        ...AssetData.attributes,
        assetType: type(AssetType).value({ id: 8, name: 'PurchaseOrder' }),

        amount: type(Number).value(0),
        currency: String,
        poDate: type(Date).null,
        postDate: type(Date).null,
        details: Details,
        components: type([ Component ]),
        shipping: Shipping,
        shipTo: ShipTo,
        billTo: BillTo,
        supplier: Supplier,
        customer: Customer,

        validationCategory: type(Number).dontSave,
    }
    isLoaded: boolean;

    get isDigitized() {
        return this.state.name == 'Digitized';
    }

    onLoaded() {
        const defaultValues = new PurchaseOrder();
        this.set({ state: defaultValues.state.clone() });
        this.isLoaded = true;
    }
}
